/**
 * Decorative TC monogram watermark using the pre-cropped emblem asset.
 * The asset lives at /tc-emblem.png in /app/frontend/public and contains
 * ONLY the TC monogram (no wordmark, no subtitle).
 * `tone="light"` inverts the artwork to a bone silhouette on dark surfaces.
 */
const EMBLEM_URL = "/tc-emblem.webp";

export default function BrandMarkWatermark({
  size = 520,
  tone = "dark",
  opacity = 0.08,
  className = "",
  style = {},
}) {
  const isLight = tone === "light";
  return (
    <img
      src={EMBLEM_URL}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`pointer-events-none select-none absolute ${className}`}
      style={{
        width: size,
        height: "auto",
        opacity,
        filter: isLight ? "brightness(0) invert(1)" : "none",
        ...style,
      }}
    />
  );
}
